export default {
  data() {
    return {
      is_loading: true,
    }
  },

  methods: {
    startLoading() {
      this.is_loading = true
    },
    endLoading(timeout = 0) {
      setTimeout(() => {
        this.is_loading = false
      }, timeout)
    },
  },
}
